import React, { useState, useEffect } from "react";
import { useLocation, Link } from "react-router-dom";
import {
  AGENCY_CATEGORIES,
  normalizeCategory,
} from "../constants/agencyCategories";

const ViewProductPage = () => {
  const location = useLocation();
  const initialProduct = location.state?.product || {
    id: "",
    name: "",
    vendorName: "",
    Locat: "",
    rentalFee: "",
    description: "",
    rating: "",
    reviews: "",
    createdAt: new Date(),
    updatedAt: new Date(),
    Category: "",
    price: "",
    quantity: "",
    images: [],
    imageCover: "",
    subcategory: "",
    color: "",
    size: "",
    brand: "",
    condition: "",
    model: "",
    transmissionType: "",
    fuelType: "",
    numberOfSeats: "",
    driver: "",
    area: "",
    bedrooms: "",
    bathrooms: "",
    cameras: false,
    pool: false,
    garden: false,
    capacity: "",
    type: "",
    buffet: "",
  };

  // States for images
  const [images, setImages] = useState([null, null, null, null, null]);
  const [mainImage, setMainImage] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // States for product details
  const [activeTab, setActiveTab] = useState(
    normalizeCategory(initialProduct.category || initialProduct.Category || AGENCY_CATEGORIES.CLOTHES)
  );
  const [subcategory, setSubcategory] = useState(initialProduct.subcategory || "");
  const [size, setSize] = useState(initialProduct.size || "");
  const [brand, setBrand] = useState(initialProduct.brand || "");
  const [condition, setCondition] = useState(initialProduct.condition || "");
  const [color, setColor] = useState(initialProduct.color || "");
  const [model, setModel] = useState(initialProduct.model || "");
  const [transmissionType, setTransmission] = useState(initialProduct.transmissionType || "");
  const [fuelType, setFuel] = useState(initialProduct.fuelType || "");
  const [numberOfSeats, setSeats] = useState(initialProduct.numberOfSeats || "");
  const [driver, setDriver] = useState(initialProduct.driver || "");
  const [area, setArea] = useState(initialProduct.area || "");
  const [bedrooms, setBedrooms] = useState(initialProduct.bedrooms || "");
  const [bathrooms, setBathrooms] = useState(initialProduct.bathrooms || "");
  const [cameras, setCameras] = useState(initialProduct.cameras || false);
  const [pool, setPool] = useState(initialProduct.pool || false);
  const [garden, setGarden] = useState(initialProduct.garden || false);
  const [capacity, setCapacity] = useState(initialProduct.capacity || "");
  const [type, setType] = useState(initialProduct.type || "");
  const [buffet, setBuffet] = useState(initialProduct.buffet || "");

  useEffect(() => {
  let imagesArray = [];

  // نحط الـ cover في الأول
  if (initialProduct.imageCover) {
    imagesArray.push(initialProduct.imageCover);
  }

  // بعدين باقي الصور (بحد أقصى 5)
  if (Array.isArray(initialProduct.images)) {
    initialProduct.images.forEach((img) => {
      if (img && imagesArray.length < 6) {
        imagesArray.push(img);
      }
    });
  }

  setImages(imagesArray);
  setMainImage(initialProduct.imageCover || imagesArray[0]);
}, [initialProduct]);


  const categoryName = initialProduct.Category || "";

  const subcategoriesMap = {
    "68a13e37b0ef38d4e9553887": "Apartments",
    "68a13f9eb0ef38d4e95538a5": "Water Venues",
    "68a13f91b0ef38d4e95538a2": "Private Venues",
    "68a13f79b0ef38d4e955389f": "Garden Venues",
    "68a13f69b0ef38d4e955389c": "Beach Resorts",
    "68a13f53b0ef38d4e9553899": "Luxury Hotels",
    "68a13e63b0ef38d4e9553890": "Coastal",
    "68a13e57b0ef38d4e955388d": "Commercial",
    "68a13e43b0ef38d4e955388a": "Townhouses",
    "68a13b53b0ef38d4e955385c": "Luxury Cars1",
    "68a13e2db0ef38d4e9553884": "Villas",
    "68a13d7ab0ef38d4e955387c": "Women's Soiree Dresses",
    "68a13d6bb0ef38d4e9553879": "Women's Wedding Dresses",
    "68a13d58b0ef38d4e9553876": "Men's Suits",
    "68a13b8bb0ef38d4e9553865": "Electric/Hybrid",
    "68a13b73b0ef38d4e9553862": "SUVs Cars",
    "68a13b61b0ef38d4e955385f": "Sports Cars",
  };

  return (
    <div className="container mx-auto p-6 gap-10 dark:text-gray-400">
      <h1 className="text-2xl font-bold text-black mb-2 dark:text-gray-200">
        Product
      </h1>

      {/* Breadcrumb */}
      <p className="text-gray-600 pb-6 text-sm flex flex-wrap gap-1 items-center dark:text-gray-400">
        <Link to="/dashboard" className="hover:underline ">
          Dashboard
        </Link>{" "}
        /{" "}
        <Link to="/products" className="hover:underline ">
          Categories
        </Link>{" "}
        /{" "}
        <Link to={`/products?selected=${categoryName}`} className="hover:underline">
          {categoryName}
        </Link>{" "}
        /{" "}
        <span className="agarly-gradient-text font-bold ">
          Product Details
        </span>
      </p>

      <div className="flex flex-col md:flex-row gap-10">
        {/* Left Side - Images */}
        <div className="bg-white rounded-2xl shadow-md p-4 md:p-6 w-full md:w-[50%] h-auto dark:bg-[#1A1A1B] dark:border dark:border-[#3D3D3D]">
          <h2 className="text-xl font-semibold mb-4 dark:text-gray-200">Product Images</h2>

          <div className="grid grid-cols-1 md:grid-cols-5 md:gap-2">
            {/* Thumbnails */}
            <div className="flex md:flex-col gap-2 mb-3 md:gap-3 justify-center md:justify-start">
              {images.map(
                (img, index) =>
                  img && (
                    <img
                      key={index}
                      src={img}
                      alt={`Product ${index + 1}`}
                      className={`w-[18%] md:w-[95px] md:h-[95px] object-cover rounded-lg cursor-pointer border-2 ${
                        mainImage === img ? "border-blue-500" : "border-gray-200"
                      }`}
                      onClick={() => setMainImage(img)}
                    />
                  )
              )}
            </div>

            {/* Main Image = Cover */}
            <div className="md:col-span-4 flex justify-center ">
              <img
                src={mainImage}
                alt="Main Product"
                className="w-[100%] md:h-[410px] p-0 md:p-2 object-cover rounded-2xl shadow cursor-pointer"
                onClick={() => setIsModalOpen(true)}
              />

              {/* Modal for Zoom */}
              {isModalOpen && (
                <div
                  className="fixed inset-0 bg-black bg-opacity-10 flex justify-center items-center z-2000"
                  onClick={() => setIsModalOpen(false)}
                >
                  <img
                    src={mainImage}
                    alt="Zoomed Product"
                    className="max-h-[90vh] max-w-[90vw] object-contain rounded-xl shadow-lg"
                  />
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Right Side - Product Info */}
        <div className="dark:text-gray-300 flex flex-col gap-3 bg-white rounded-2xl p-6 shadow-md w-full md:w-[50%] dark:bg-[#1A1A1B] dark:border dark:border-[#3D3D3D]">
          <h2 className="text-3xl mb-2">
            <span className="agarly-gradient-text font-bold ">
              {initialProduct.name}
            </span>
          </h2>
          <p className="dark:text-gray-300">
            <span className="font-bold text-gray-700 dark:text-gray-500 ">Vendor:</span>{" "}
            {initialProduct.vendorName}
          </p>
          <p>
            <span className="font-bold text-gray-700 dark:text-gray-500 ">Category:</span>{" "}
            {initialProduct.Category}{" "}
          </p>
          <p>
            <span className="font-bold text-gray-700 dark:text-gray-500 ">Rental Fee:</span>{" "}
            {initialProduct.rentalFee}
          </p>
          <p>
            <span className="font-bold text-gray-700 dark:text-gray-500 ">Description:</span>{" "}
            {initialProduct.description}
          </p>
          <p>
            <span className="font-bold text-gray-700 dark:text-gray-500 ">Rating:</span>{" "}
            {initialProduct.rating}{" "}
          </p>
          <p>
            <span className="font-bold text-gray-700 dark:text-gray-500 ]">Created At:</span>{" "}
            {new Date(initialProduct.createdAt).toLocaleDateString()}
          </p>
          <p>
            <span className="font-bold text-gray-700 dark:text-gray-500">Updated At:</span>{" "}
            {new Date(initialProduct.updatedAt).toLocaleDateString()}
          </p>
          <p>
            <span className="font-bold text-gray-700 dark:text-gray-500">Reviews:</span>
            {initialProduct.reviews}
          </p>

          {/* Tab Content */}
          <div className=" mt-4">
            {normalizeCategory(categoryName) === AGENCY_CATEGORIES.CLOTHES && (
              <div className="space-y-2">
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Subcategory:</span>{" "}
                  {subcategoriesMap[subcategory] || "Unknown"}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Size:</span> {size}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Color:</span> {color}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Brand:</span> {brand}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Condition:</span>{" "}
                  {condition}
                </p>
              </div>
            )}

            {normalizeCategory(categoryName) === AGENCY_CATEGORIES.CARS && (
              <div className="space-y-2">
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Subcategory:</span>{" "}
                  {subcategory}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Brand:</span> {brand}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Model:</span> {model}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Transmission:</span>{" "}
                  {transmissionType}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Fuel:</span> {fuelType} 
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Seats:</span> {numberOfSeats}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Driver:</span>{" "}
                  {driver}
                </p>
              </div>
            )}

            {normalizeCategory(categoryName) === AGENCY_CATEGORIES.REAL_ESTATE && (
              <div className="space-y-2">
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Subcategory:</span>{" "}
                  {subcategory}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Area:</span> {area} m²
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Bedrooms:</span>{" "}
                  {bedrooms}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Bathrooms:</span>{" "}
                  {bathrooms}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Cameras:</span>{" "}
                  {cameras ? "Yes" : "No"}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Pool:</span>{" "}
                  {pool ? "Yes" : "No"}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Garden:</span>{" "}
                  {garden ? "Yes" : "No"}
                </p>
              </div>
            )}

            {normalizeCategory(categoryName) === AGENCY_CATEGORIES.WEDDING && (
              <div className="space-y-2">
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Subcategory:</span>{" "}
                  {subcategory}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Area:</span> {area} m²
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Capacity:</span>{" "}
                  {capacity}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Type:</span> {type}
                </p>
                <p>
                  <span className="font-bold text-gray-700 dark:text-gray-500">Buffet:</span>{" "}
                  {buffet}
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
      <div style={{ height: "40px" }}></div>
    </div>
  );
};

export default ViewProductPage;
